// extracted by mini-css-extract-plugin
export default {"noviceRecommendationPanel":"index_noviceRecommendationPanel__ohNAY","noviceRecommendationPanelHeader":"index_noviceRecommendationPanelHeader__bHKSo"};